
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';

const ContactCTASection: React.FC = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  
  const handleContactClick = () => {
    // Navigate to the contact page
    navigate('/contact');
    
    // Ensure we're at the top of the page
    window.scrollTo(0, 0);
  };
  
  return (
    <section id="contact-cta" className="py-20 bg-[#0D1F2D] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-lg bg-[#2F4550] p-8 md:p-10 lg:p-12 relative overflow-hidden shadow-md">
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-green-500/5 rounded-full blur-3xl"></div>
          
          <div className="relative z-10 max-w-3xl">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-space-grotesk font-bold mb-6">
              {t('ready_to_learn')}
            </h2>
            
            <p className="text-lg text-white/80 mb-8">
              {t('connect_with_us')}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md flex items-center gap-2 transition-all"
                onClick={handleContactClick}
              >
                {t('contact_us')}
                <ArrowRight className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTASection;
